import { render, staticRenderFns } from "./TypeControlList.vue?vue&type=template&id=8ab3feb4&scoped=true"
import script from "./TypeControlList.vue?vue&type=script&lang=js"
export * from "./TypeControlList.vue?vue&type=script&lang=js"
import style0 from "./TypeControlList.vue?vue&type=style&index=0&id=8ab3feb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab3feb4",
  null
  
)

export default component.exports